<template>
  <div class="el-progress el-progress--circle">
    <div class="el-progress-circle" style="height: 48px; width: 48px">
      <svg viewBox="0 0 100 100">
        <!--定义渐变-->
        <defs>
          <linearGradient :id="colorId" x1="0" y1="0" x2="1" y2="1">
            <stop
              offset="0%"
              :style="`stop-color:${shade[0]}`"
              stop-opacity="0.8"
            ></stop>
            <stop
              offset="100%"
              :style="`stop-color:${shade[1]}`"
              stop-opacity="1"
            ></stop>
          </linearGradient>
        </defs>
        <!--
          第1个path是灰色的背景环形
          stroke-width： 进度条的宽细
          stroke：颜色
        -->
        <path
          d="
          M 50 50
        m 0 -45
        a 40 40 0 1 1 0 90
        a 40 40 0 1 1 0 -90
        "
          stroke="#F0F2F6"
          stroke-width="10"
          stroke-linecap="round"
          fill="none"
          class="el-progress-circle__track"
          style="stroke-dasharray: 295.31px, 295.31px; stroke-dashoffset: 0px"
        ></path>

        <!--
          第1个path是灰色的背景环形
          stroke-width： 进度条的宽细
          stroke：颜色
        -->
        <path
          d="
          M 50 50
        m 0 -45
        a 40 40 0 1 1 0 90
        a 40 40 0 1 1 0 -90

        "
          :stroke="`url(#${colorId})`"
          fill="none"
          stroke-linecap="round"
          stroke-width="10"
          class="el-progress-circle__path"
          :style="`stroke-dasharray: ${calcProgress()}px, 295.31px; stroke-dashoffset: 0px; transition: stroke-dasharray 0.6s ease 0s, stroke 0.6s ease 0s;`"
        ></path>
      </svg>
    </div>
    <div class="my el-progress__text">
      <div class="per">{{ percentage }} <span class="num">%</span></div>
      <div class="text">正确率</div>
    </div>
  </div>
</template>

<script>
// import uuid from "uuid";
export default {
  name: "CircleProgress",
  props: {
    //百分比
    percentage: {
      type: Number,
      default: 0,
    },

    //渐变
    shade: {
      type: Array,
      default: () => {
        return ["white", "black"];
      },
    },
  },
  data() {
    return {
      //svg渐变的id，需要保证唯一否则颜色会重复
      colorId: null,
    };
  },
  created() {
    this.colorId = "colorful-" + Math.random();
  },
  methods: {
    calcProgress() {
      //百分之一的值等于svg的stroke-dasharray的2.9531
      return this.percentage * 2.9531;
    },
  },
};
</script>

<style lang="less" scoped>
.el-progress__text {
  .per {
    font-size: 14px;
    line-height: 14px;
    text-align: center;
    color: #333333;
    .num {
      font-size: 10px;
    }
  }
  .text {
    font-size: 8px;
    line-height: 10px;
    color: #a8aab8;
  }
}
</style>
